import { z } from "zod";

import { validatePhoneNumber } from "./lib/helpers";

const emailCheckCache = new Map<string, boolean>();
export const SignUpSchemaAsStaff = (
  emailExists: (email: string) => Promise<boolean>,
) =>
  z.object({
    email: z
      .string()
      .trim()
      .email()
      .min(1, "common.required")
      .pipe(
        z.string().refine(async (email) => {
          if (emailCheckCache.has(email)) {
            return emailCheckCache.get(email);
          }
          const result = !(await emailExists(email));
          emailCheckCache.set(email, result);
          return result;
        }, "signUpScreen.validation.emailExists"),
      ),
    firstName: z.string().trim().min(1, "common.required"),
    lastName: z.string().trim().min(1, "common.required"),
    mobileNumber: z
      .string()
      .trim()
      .min(1, "common.required")
      .refine((e) => !e || validatePhoneNumber(e), {
        message: `validation.phoneNumber`,
      }),
  });
export const SignUpSchema = (
  emailExists: (email: string) => Promise<boolean>,
) =>
  SignUpSchemaAsStaff(emailExists).extend({
    passwordGroup: z
      .object({
        password: z.string().min(1, "common.required"),
        confirmPassword: z.string().min(1, "common.required"),
      })
      .refine((data) => data.password === data.confirmPassword, {
        message: "signUpScreen.validation.passwordsDoNotMatch",
        path: ["confirmPassword"],
      }),
    termsAndConditions: z
      .boolean()
      .refine(
        (value) => value,
        "signUpScreen.validation.termsAndConditionsRequired",
      ),
  });
